module.exports = __webpack_public_path__ + "01bcf97ccd4b0e1078b4b54f4a48282f.svg";